(function($){

	$(document).ready(function(){

	    var country = getCookie("country");
      
          if (country != "")
          {
            displayCartIcon(country);
            displayButton(country);
            displayHeroTitle(country);
          }

          else
          {
          	geoip2.country(onSuccess, onError);
          }
      	});


  var onSuccess = function(location)
  {
    displayButton(location.country.iso_code);
    displayHeroTitle(location.country.iso_code);
    setCookie("country", location.country.iso_code, 30);
    
  };

  var onError = function(error)
  {
  	showFindStoreButton();
  }
  
  function displayCartIcon(iso)
  {
    switch(iso)
            {		
              case "US":
                showCartIcon();
                break;
              case "CA":
                // Add code here when Canadian store is launched
                //showCartIcon();
                break;
              default:
                break;					
      		}
  }
  
  function displayHeroTitle(iso)
	{
       	if(window.location.pathname == "/")
        {
            switch(iso)
            {		
              case "US":
                updateHeroTitle();
                break;
              case "CA":
                // Add code here when Canadian store is launched
                //updateHeroTitle();
                break;
              default:
                break;					
      		}
       	}

	}
  function updateHeroTitle()
	{
        document.getElementById("change-hero-text").innerHTML = "Now Shipping Across the United States";
      
	}

	function displayButton(iso)
	{
      	if(window.location.href.indexOf("/products/") > -1)
        {
       
			switch(iso)
			{		
				case "AT":
					showBuyButton(iso);
					break;
				case "BE":
					showBuyButton(iso);
					break;
				case "CH":
					showBuyButton(iso);
					break;
				case "CZ":
					showBuyButton(iso);
					break;
				case "DE":
					showBuyButton(iso);
					break;
				case "DK":
					showBuyButton(iso);
					break;
				case "ES":
					showBuyButton(iso);
					break;
				case "FI":
					showBuyButton(iso);
					break;
				case "FR":
					showBuyButton(iso);
					break;
				case "GB":
					showBuyButton(iso);
					break;	
				case "HU":
					showBuyButton(iso);
					break;																			
				case "IE":
					showBuyButton(iso);
					break;
				case "IT":
					showBuyButton(iso);
					break;
				case "NL":
					showBuyButton(iso);
					break;
				case "NO":
					showBuyButton(iso);
					break;
				case "PL":
					showBuyButton(iso);
					break;
				case "PT":
					showBuyButton(iso);
					break;
				case "SE":
					showBuyButton(iso);
					break;
                case "US":
          			showAddToCartButton();
                	showFindStoreButton();
                    showProductItemPrice();
          			break;
                case "CA":
                	// Add code here when Canadian store is launched
          			//showAddToCartButton();
                    //showProductItemPrice();
                	showFindStoreButton();
          			break;
				default:
					showFindStoreButton();
					break;					
			}
		}
	}
	  	
  	function showProductItemPrice()
	{
		var find = document.getElementById("product-items-price")
		find.removeAttribute("class");
	}
    
  
    function showCartIcon()
	{
		var find = document.getElementById("corner-cart-icon")
		find.removeAttribute("class");
	}

	function showBuyButton(iso)
	{
		var buy = document.getElementById("buy-now");
        document.getElementById("buy-link").href="https://shop.paperblanks.com/" + iso  + "/en/824-exchange_ipad_covers"; 

		buy.removeAttribute("class");
	}

	function showFindStoreButton()
	{
		var find = document.getElementById("find-a-store")
		find.removeAttribute("class");
	}
  
  	function showAddToCartButton()
	{
		var find = document.getElementById("add-to-cart")
		find.removeAttribute("class");
	}

	function setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+d.toUTCString();
	    document.cookie = cname + "=" + cvalue + "; " + expires+";path=/";
	}
	
	function getCookie(cname) {
	    var name = cname + "=";
	    var ca = document.cookie.split(';');
	    for(var i=0; i<ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0)==' ') c = c.substring(1);
	        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
	    }
	    return "";
	}

})(jQuery);